export const experience = [
  {
    company: "Wizeline",
    role: "Senior Frontend Engineer",
    period: "Sep 2023 — Present",
    size: "2,000+ employees",
    team: "Cross-functional client team",
    logo: "/images/brands/wizeline.png",
    techs: [
      "React",
      "Next.js",
      "TypeScript",
      "Storybook",
      "GraphQL",
      "Jest",
      "RTL",
      "MSW",
      "AI-assisted development",
    ],
    milestone:
      "Consultant for Dow Jones on WSJ+, translating product and Figma requirements into accessible React and TypeScript experiences for subscribers across The Wall Street Journal, Barron’s, and MarketWatch. Completed approximately 70% of feature tickets during the final redesign phase, helping the team deliver the launch on time. Increased automated test coverage from 32% to 78.95% with Jest, React Testing Library, and MSW, while resolving more than 100 recurring console errors and warnings.",
  },
  {
    company: "Globant",
    role: "Semisenior Frontend Engineer",
    period: "Jun 2022 — Aug 2023",
    size: "28,000+ employees",
    team: "~10 frontend engineers",
    logo: "/images/brands/globant.png",
    techs: ["React", "TypeScript", "Redux", "Storybook", "GraphQL", "Jest"],
    milestone:
      "Built a content-planning tool for Disney+, Hulu, Star+, and ESPN+ using React, TypeScript, Redux, Storybook, GraphQL, and Jest. Helped the team reach approximately 85% unit-test coverage and completed around two code reviews per week to protect quality and maintainability. Shared clean-code practices with a pod of roughly 10 frontend engineers, interviewed approximately 30 candidates, and mentored an intern.",
  },
  {
    company: "Perficient / Talos Digital",
    role: "Frontend Engineer",
    period: "Aug 2020 — Jun 2022",
    size: "7,000+ employees",
    team: "~20 developers",
    logo: "/images/brands/perficient.png",
    techs: ["React", "JavaScript", "Redux Toolkit", "Python"],
    milestone:
      "Built React and Redux Toolkit products for All.health as part of a team of approximately 20 developers, including a CMS supporting a mobile health experience used by around 200 patients and medical staff. Automated CMS workflows with Python, reducing processing time from three months to one week while handling approximately 2,000 content items weekly. Also delivered patient-acquisition and operations tools, including a Calendly integration and a survey application serving around 100 applicants per month.",
  },
];

export const clients = [
  {
    name: "Dow Jones",
    url: "https://www.dowjones.com/",
    logo: "/images/brands/dow-jones.svg",
    className: "dowJones",
    industry: "Financial information",
  },
  {
    name: "The Wall Street Journal",
    url: "https://www.wsj.com/",
    logo: "/images/brands/wsj.svg",
    className: "wsj",
    industry: "News & media",
  },
  {
    name: "Disney",
    url: "https://thewaltdisneycompany.com/",
    logo: "/images/brands/disney.png",
    className: "disney",
    industry: "Entertainment",
  },
  {
    name: "All.health",
    url: "https://all.health/",
    className: "allHealth",
    industry: "Digital health",
  },
];
